module.exports = __webpack_public_path__ + "img/rural_store.f267d293.jpg";